// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';

// import modules
import DefaultContainer from '../../modules/Containers/DefaultContainer';

export default function PageNotFound() {

    return (
        <DefaultContainer>
            <div className="horizontal-vertical-center">
                <center>
                    <div className="not-found-text">
                        404
                    </div>
                    <div className="not-found-textsub">
                        Page Not Found
                    </div>
                </center>
            </div>
        </DefaultContainer>
    );
}
